module.exports = __webpack_public_path__ + "media/fonts/MatterSQ-Medium-a503ddce64403cefb9e92ddb5755108d.ttf";